enum ChecklistTemplateType {
  CHECKIN = 1,
  NON_CHECKIN = 2,
}

export default ChecklistTemplateType;
